import React from "react";
// Date and Time Picker Popover

// Default
import { useState } from "react";
import { Map, Marker, Overlay } from "pigeon-maps";

// Mui
import Popover from "@mui/material/Popover";
import Box from "@mui/material/Box";

// Svg
import Meter from "../../assets/svg/meter";

// Json
import markersData from "../../json/Meter.json";

// Types
interface MarkerData {
  latitude: number;
  longitude: number;
  status: string;
  [key: string]: any;
}

interface MapViewPopoverProps {
  mapView: HTMLElement | null;
  setMapView: (element: HTMLElement | null) => void;
}

const MapViewPopover: React.FC<MapViewPopoverProps> = ({
  mapView,
  setMapView,
}) => {
  const [selectedMarker, setSelectedMarker] = useState<MarkerData | null>(null);
  const [zoom, setZoom] = useState(14);
  const defaultCenter: [number, number] = [18.5204, 73.8967];

  const grayScaleProvider = (x: number, y: number, z: number, dpr?: number) => {
    return `https://cartodb-basemaps-a.global.ssl.fastly.net/light_all/${z}/${x}/${y}@${dpr}x.png`;
  };

  const handleMarkerClick = (marker: MarkerData) => {
    setSelectedMarker(marker);
    setZoom(14);
  };

  const zoomIn = () => setZoom((prevZoom) => Math.min(prevZoom + 1, 18));
  const zoomOut = () => setZoom((prevZoom) => Math.max(prevZoom - 1, 11));

  const handleClose = () => {
    setMapView(null);
  };

  return (
    <Popover
      open={!!mapView}
      anchorEl={mapView}
      onClose={handleClose}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
      PaperProps={{
        sx: {
          width: "700px",
          height: "450px",
          maxWidth: "none",
          overflow: "hidden",
          p: 0,
        },
      }}
    >
      <Box
        sx={{
          position: "relative",
          height: "450px",
          width: "700px",
          p: 0,
          bgcolor: "red",
        }}
      >
        <Map
          height={6500}
          width={7000}
          center={
            selectedMarker
              ? [selectedMarker.latitude, selectedMarker.longitude]
              : defaultCenter
          }
          zoom={zoom}
          defaultZoom={14}
          provider={grayScaleProvider}
          attribution={false}
        >
          {markersData?.markers
            ?.slice(0, 15)
            ?.map((marker: MarkerData, index: number) => (
              <Marker
                key={index}
                width={30}
                anchor={[marker.latitude, marker.longitude]}
                onClick={() => handleMarkerClick(marker)}
              >
                <Meter
                  fill={marker.status === "active" ? "#34C759" : "#FF3B30"}
                />
              </Marker>
            ))}
          {selectedMarker && (
            <Overlay
              anchor={[selectedMarker.latitude, selectedMarker.longitude]}
            ></Overlay>
          )}
        </Map>

        <Box
          sx={{
            position: "absolute",
            bottom: "40px",
            right: "40px",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <button
            onClick={zoomIn}
            style={{
              padding: "2px 5px",
              backgroundColor: "white",
              border: "1px solid #5F6368",
              borderRadius: "3px 3px 0 0",
              cursor: "pointer",
            }}
          >
            +
          </button>
          <button
            onClick={zoomOut}
            style={{
              padding: "2px 5px",
              backgroundColor: "white",
              border: "1px solid #5F6368",
              borderRadius: "0 0 3px 3px",
              cursor: "pointer",
            }}
          >
            -
          </button>
        </Box>
      </Box>
    </Popover>
  );
};

export default MapViewPopover;
